import React, { useState } from 'react';
import { FlatList } from "react-native"
import type { MarketProps } from '../../types';
import { Switch } from '../../Components';
import SearchBox from '../../Components/SearchBox';
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';

type MarketSelectorProps = {
    markets:MarketProps[],
    selected_markets:string[],
    onSelectMarket: (market:MarketProps) => void,
    onDeselectMarket: (market:MarketProps) => void,
    onClose:() => void
}
const MarketSelector = ({ markets, selected_markets, onSelectMarket, onDeselectMarket, onClose } : MarketSelectorProps) => {
    const [ search_value, setSearchValue ] = useState('');
    const Colors = useColors();
    const filtered_markets = markets.filter(m => `${m.type} ${m.description}`.toLowerCase().includes(search_value.toLowerCase())).sort((a,b) => {
        return Number(b.primary_market) - Number(a.primary_market)
    })

    const renderMarkets = (data:{item:MarketProps, index:number}) => {
        const selected = selected_markets.includes(data.item.market_id) ? true : false
        return (
            <Button style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }} onPress={() => selected ? onDeselectMarket(data.item) : onSelectMarket(data.item)}>
                <View transparent style={{ flex:1, marginRight:10 }}>
                    <Text size={14} theme='h1'>{data.item.type == 'Stat' ? data.item.stat_label : data.item.type}</Text>
                    <Text style={{ marginTop:3 }} size={14} theme='description'>{data.item.description}</Text>
                </View>
                <Switch 
                    switch_type="on_off"
                    value={selected}
                    onChange={() => {
                        if(!selected){ return onSelectMarket(data.item) }
                        return onDeselectMarket(data.item)
                    }}
                />
            </Button>
        )
    }

    return (
        <View float style={{ flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:20, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>MANAGE MARKETS</Text>
                    <Text theme='description'>Toggle markets to be included with the selected contest</Text>
                </View>
            </View>
             <View style={{ padding:10 }}>
                <SearchBox 
                    onChange={(text) => setSearchValue(text)}
                    hide_search_button
                />
            </View>
            <View style={{ flex:1 }}>
                <FlatList
                    data={filtered_markets}
                    renderItem={renderMarkets}
                    keyExtractor={(item) => item.market_id.toString()}
                />
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <Button
                    title='CLOSE'
                    style={{ flex:1 }}
                    type='error'
                    onPress={() => onClose()}
                />
            </View>
        </View>
    )
}

export default MarketSelector